/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeVimeoPlayerData } from './moe-vimeo-player.data';
import { IMoeVimeoPlayerProps } from './moe-vimeo-player.props.autogenerated';

export interface IMoeVimeoPlayerViewProps extends IMoeVimeoPlayerProps<IMoeVimeoPlayerData> {}

/**
 *
 * MoeVimeoPlayer component
 * @extends {React.PureComponent<IMoeVimeoPlayerProps<IMoeVimeoPlayerData>>}
 */
class MoeVimeoPlayer extends React.PureComponent<IMoeVimeoPlayerProps<IMoeVimeoPlayerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeVimeoPlayer;
